import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleLogin = async (e) => {
        e.preventDefault();
        console.log('Enviando:', { username, password });
        fetch(`${apiUrl}/api/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Falha na autenticação');
                }
                return response.json();
            })
            .then(data => {
                if (!data.token) {
                    throw new Error('Token não recebido');
                }
                localStorage.setItem('token', data.token);
                const adminData = {
                    value: data.is_admin,
                    expires: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).toISOString()
                };
                localStorage.setItem('is_admin', JSON.stringify(adminData));
                navigate('/');
            })
            .catch(error => {
                console.error('Erro:', error);
                setError(error.message || 'Erro desconhecido');
            });

    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-background">
            <div className="w-full max-w-xs">
                <h1 className="text-2xl font-medium font-ltrenovate text-gray-800 mb-4 text-center">
                    Faça login como Administrador
                </h1>
                <form onSubmit={handleLogin} className="bg-white shadow-2xl rounded px-8 pt-6 pb-8 mb-4">
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="user">
                            Usuário
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="user"
                            type="text"
                            placeholder="Usuário"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                            Senha
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                            id="password"
                            type="password"
                            placeholder="********"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="flex items-center justify-between">
                        <button
                            className="bg-primary hover:bg-primaryHover transition-colors duration-300 ease-in-out text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            type="submit"
                        >
                            Entrar
                        </button>
                    </div>
                </form>
                {error && <p>{error}</p>}
            </div>
        </div>
    );
};

export default LoginPage;
